import head from 'lodash/head';

export class ReportPageService {
    _getOverviewDetailsObject(details) {
        return {
            contentId: details.content_id,
            menuId: details.menu_id,
            displayName: details.display_name,
            name: details.name,
            title: details.title,
            description: details.description
        }
    }

    _getContentObject(values) {
        return _getContentData(head(values).values);

        function _getContentData(data) {
            return data.map(value => ({
                pdf: value.pdf,
                title: value.title,
                image: value.image,
                description: value.description,
                createdAt: value.created_at
            }));
        }
    }

	/**
	 * function to get conference materials content
	 * @return {object} [information related to conference materials]
	 */

    getReportDetails(details) {
        return {
            menuOverviewDetails: this._getOverviewDetailsObject(details.data.menuOverviewDetails),
            details: this._getContentObject(details.data.content)
        };
    }
}


// WEBPACK FOOTER //
// ./src/app/common/components/report-page/report-page.service.js